import React from 'react';
import './slider-decopanelrolls.css';
import Printrolls1 from '../../images/flet-sm-4.webp';
import Printrolls2 from '../../images/flet-sm-4.webp';

function slider() {
	return (
	  
	<>
	<div id="slider-decopanelrolls">
		<div id="carouselExampleIndicators6" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators6" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators6" data-slide-to="1"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Printrolls1} alt="Print Rolls1" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h2>PLAIN/PRINT ROLLS</h2>
					</div>
				</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Printrolls2} alt="Print Rolls2" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h2>PLAIN/PRINT ROLLS</h2>
					</div>
				</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators6" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators6" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;